import type { RouteObject } from "react-router-dom";

import { AuthenticatedRoute, AuthenticationMixedRoute, AuthenticationRoute } from "./components";
import {
	LoggedOut,
	Login,
	LoginInterstitial,
	LoginPassword,
	LoginSsoError,
	LoginSsoTroubleshoot,
	LoginSsoVerify,
	LoginToken,
	NoLicense,
	PasswordReset,
	PasswordResetComplete,
	PasswordResetVerify,
	StartLogin,
} from "./views";

export const routes: RouteObject[] = [
	{
		path: "/start-login",
		element: (
			<AuthenticationRoute>
				<StartLogin />
			</AuthenticationRoute>
		),
	},
	{
		path: "/logged-out",
		element: <LoggedOut />,
	},
	{
		path: "/no-license",
		element: (
			<AuthenticatedRoute>
				<NoLicense />
			</AuthenticatedRoute>
		),
	},
	{
		path: "/login",
		element: (
			<AuthenticationRoute>
				<Login />
			</AuthenticationRoute>
		),
	},
	{
		path: "/login-interstitial",
		element: (
			<AuthenticationMixedRoute>
				<AuthenticationRoute>
					<LoginInterstitial />
				</AuthenticationRoute>
			</AuthenticationMixedRoute>
		),
	},
	{
		path: "/login-password",
		element: (
			<AuthenticationMixedRoute>
				<AuthenticationRoute>
					<LoginPassword />
				</AuthenticationRoute>
			</AuthenticationMixedRoute>
		),
	},
	// TODO @eb @ah - investigate if we can consolidate the sso error routes into one, and ensure all sso errors are redirected to it with a reason query parameter to display appropriate messaging
	{
		path: "/sso-error",
		element: (
			<AuthenticationRoute>
				<LoginSsoError />
			</AuthenticationRoute>
		),
	},
	{
		path: "/login-sso-error",
		element: (
			<AuthenticationRoute>
				<LoginSsoError />
			</AuthenticationRoute>
		),
	},
	{
		path: "/login-sso-troubleshoot",
		element: (
			<AuthenticationRoute>
				<LoginSsoTroubleshoot />
			</AuthenticationRoute>
		),
	},
	{
		path: "/login-sso-verify",
		element: (
			<AuthenticationRoute>
				<LoginSsoVerify />
			</AuthenticationRoute>
		),
	},
	{
		path: "/login-token",
		element: (
			<AuthenticationRoute>
				<LoginToken />
			</AuthenticationRoute>
		),
	},
	{
		path: "/password-reset",
		element: (
			<AuthenticationMixedRoute>
				<PasswordReset />
			</AuthenticationMixedRoute>
		),
	},
	{
		path: "/password-reset-verify",
		element: (
			<AuthenticationMixedRoute>
				<PasswordResetVerify />
			</AuthenticationMixedRoute>
		),
	},
	{
		path: "/password-reset-complete",
		element: (
			<AuthenticationMixedRoute>
				<PasswordResetComplete />
			</AuthenticationMixedRoute>
		),
	},
];
